<template>
    <div class="rules" v-bind:style="{ paddingBottom: $store.state.paddingBottom + 'px' }">
        
        <NavigationBar>
          <template v-slot:left>
            <img v-if="loggedIn" class="back" src="../assets/icons/ic_16_back.svg" v-on:click="goBack" data-testid="nav-back">
            <div v-else></div>
          </template>
            <template v-slot:center>
              {{ $t('profile.manage_notifications') }}
            </template>
        </NavigationBar>

        <div v-if="newsletterContext" class="input-container" style="margin-top: 20px;">
          <div v-if="email && email.length > 0" class="input-infotext" data-testid="unsubscribe-message">
            {{ $t('profile.manage_newsletter_text', { email_adress: email }) }}
          </div>
        </div>
        <div v-else class="input-container" style="margin-top: 20px;">
            <div v-if="email && email.length > 0" class="input-infotext" data-testid="unsubscribe-message">
              {{ $t('profile.manage_notifications_text', { email_adress: email }) }}
            </div>
        </div>
      
    </div>
</template>

<script>
  import NavigationBar from '../components/NavigationBar'
  import Vue from 'vue'
  import { TOAST_DURATION } from '../main'
  
  export default {
    name: 'UnsubscribeEmailNotifications',
    components: { NavigationBar },
    data() {
      return {
        email: '',
        context: ''
      }
    },
    computed: {
      newsletterContext() {
        return this.context && this.context === 'news'
      },
      loggedIn() {
        return this.$store.getters.loggedIn
      },
    },
    created () {
      this.$log.debug('UnsubscribeEmailNotifications created ' + this.$route.query.user + ' - ' + this.$route.query.email)
      const id = parseInt(this.$route.query.user)
      this.email = this.$route.query.email
      this.context = this.$route.query.context
      Vue.$log.debug('postUnsubscription start ' + id + ' --- ' + this.email)
      if(id !== undefined && this.email !== undefined) {
        const insertUnsubscription = {
          'fk_user': parseInt(id),
          'email': this.email
        }
        Vue.$log.debug('postUnsubscription ' + JSON.stringify(insertUnsubscription))
        if(this.loggedIn && this.$store.state.user && this.$store.state.user.id === id && 
            this.$store.state.user.email === this.email && this.$store.state.user.email_notifications === true) {
          this.$store.dispatch('patchUser', { email_notifications: false }).then(() => {
            Vue.$log.debug('postUnsubscription patchUser ok ')
          })
        }
        this.$store.dispatch('postUnsubscription', insertUnsubscription).then(response => {
          Vue.$log.debug('postUnsubscription ok ' + JSON.stringify(response))
          this.$toast.open({
            message: this.$i18n.t('profile.send_no_more_emails'),
            position: 'top',
            duration: TOAST_DURATION,
            type: 'success'
          })
        }, error => {
          Vue.$log.debug('postUnsubscription error ' + error.toString())
        })
      } else {
        Vue.$log.debug('postUnsubscription error ' + id + ' --- ' + email)
      }
    },
    methods: {
      goBack () {
        if (this.$store.getters.loggedIn) {
          this.$router.push({ name: 'profilechangenotifications' }).catch(err => {
          })
        } else {
          this.$router.push({ name: 'home' })
        }
      }
    }
  }
  
</script>

<style lang="scss" scoped>
</style>
